import axios from 'axios';
import { auth } from './firebase/index';

const instance = axios.create({
    baseURL: process.env.REACT_APP_FIREBASE_DATABASE_URL
});

instance.interceptors.request.use(async config => {
    if (auth.currentUser) {
        const token = await auth.currentUser.getIdToken();
        config.params = { ...config.params, auth: token };
    }
    return config;
});

export default instance;
